module.exports = new __parcel__URL__("step_five_vector_light_optimal.7f2549c4.png").toString();